import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ImageMapper from 'react-img-mapper';
import ReactTooltip from 'react-tooltip';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
// import SweetAlert from "react-bootstrap-sweetalert";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import {BASE_URL} from '../../config/constants';

class DetailAsset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataAsset: [],
      dataComplaint: [],
      dataJoblist: [],
      dataQR: [],
      dataLayout: [],
      selectedLayout: '',
      layoutFile: '',
      hoveredArea: null,
      msg: '',
      moveMsg: '',
      mapAreas: [],
      layoutLoading: true,
      showModalDetail: false,
      assetDetailPopup: null
    };

    this.selectedData = window.history.state.state.selectedData;
  };

  componentDidMount(){
    this.getDataComplaint();
    // this.getDataJoblist();
    this.getDataQR();
    this.getDataLayout();
  };

  getDataComplaint = () => {
    const param = { params: { assetId: this.selectedData._id } };
    Services.getComplaintList(param)
    .then(res => {
      this.setState({dataComplaint: res});
    })
    .catch(err => console.log(err));
  };

  getDataJoblist = () => {
    const param = { params: { assetId: this.selectedData._id } };
    Services.getJobListByParam(param)
    .then(res => {
      this.setState({dataJoblist: res});
    })
    .catch(err => console.log(err));
  };

  getDataQR = () => {
    const payload = {
      type: 'assets-data',
      id: this.selectedData._id
    };

    Services.getQRCode(payload)
    .then(res => {
      this.setState({dataQR: res});
    })
    .catch(err => console.log(err));
  }

  getDataLayout = () => {
    Services.getZoneLayout()
      .then(res => {
        this.setState({ dataLayout: res }, this.getDataAsset());
      })
      .catch(err => console.log(err));
  };

  getDataAsset = () => {
    const param = { params: { id: this.selectedData._id } };
    Services.getAssetDetail(param)
    .then(res => {
      if(res.layoutId){
        const selectedLayouts = this.state.dataLayout?.find(layout => (layout._id === res.layoutId));
        if(selectedLayouts){
          this.setState({dataAsset: res, selectedLayout: res.layoutId, layoutFile: selectedLayouts?.file ?? undefined, layoutLoading: false });
          this.getLayoutAssetCoordinates(res.layoutId, res._id);
        }else{
          this.setState({dataAsset: res, layoutLoading: false });
        }
      }else{
        this.setState({dataAsset: res, layoutLoading: false});
      }
    })
    .catch(err => {
      console.log("error get data asset", err);
      this.setState({layoutLoading: false});
    });
  };

  getLayoutAssetCoordinates = (layoutZoneId, assetId) => {
    const params = {
      layoutZoneId,
      assetId
    }
    Services.getLayoutAssetCoordinates({params})
      .then(res => {
        this.setState({ mapAreas: res.assetData },
          () => setTimeout(this.setState({layoutLoading: false}), 2000)  
        );
      })
      .catch(err => console.log(err));
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item"><Link to="/master/asset-management">Aset</Link></li>
        <li className="breadcrumb-item active">Detail</li>
      </ol>
      <h1 className="page-header">Detail Aset </h1>
    </div>
  );

  renderDetailAsset = () => {
    const { dataAsset } = this.state;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>Detail Aset</PanelHeader>
          <PanelBody>
            <div className="row">
              <div className="col-xl-9">
                <div className="table-responsive">
                  <table className="table table-striped m-b-0">
                    <thead>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Nama</th>
                        <th>{dataAsset.name}</th>
                      </tr>
                      <tr>
                        <td>Serial Number</td>
                        <td>{dataAsset.serialNumber}</td>
                      </tr>
                      <tr>
                        <td>Kategori</td>
                        <td>{dataAsset.categoryName}</td>
                      </tr>
                      <tr>
                        <td>Tahun</td>
                        <td>{dataAsset.year}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-xl-3">
                {this.renderQRImage()}
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderQRImage = () => {
    const { dataQR } = this.state;

    return (
      <div style={{textAlign: 'center'}}>
        <img
          src={dataQR.file}
          style={{ maxWidth: "250px", maxHeight: '90%', objectFit: 'cover'}}
          alt="qr_asset"
          // onClick={() => {
          //   setImage(item.file);
          //   toggleModal();
          // }}
        />
        <div style={{textAlign: 'center'}}>
          <a download={this.state.dataAsset.name + " QR.jpg"} href={`data:${this.state.dataQR.file}`}>
            <button type="button" className="btn btn-success">Download</button>
          </a>
        </div>
      </div>
    )
  }

  renderLayoutMapper = () =>{
    const layoutOptions = this.state.dataLayout.length > 0
      && this.state.dataLayout.map((item, i) => {
        return (
          <option key={i} value={item._id}>{item.name}</option>
        )
      }, this);
    
    const handleLayoutChange = (e) => {
      const {value} = e.target;
      if(value){
        const selectedLayouts = this.state.dataLayout.filter(layout => (layout._id === value));
        this.setState({ 
          selectedLayout: value, 
          layoutFile: selectedLayouts[0].file,
          layoutLoading: true,
        }, this.getLayoutAssetCoordinates(value, this.state.dataAsset._id));
      }else{
        this.setState({ selectedLayout: value, layoutFile: '' });
      }
    };
    
    const getAssetDetail = (assetId) => {
      const param = { params: { id: assetId } };
      Services.getAssetDetail(param)
      .then(res => {
        this.setState({assetDetailPopup: res});
      })
      .catch(err => console.log(err));
    };

    const toggleModalDetail = (assetId) => {
      if(assetId){
        getAssetDetail(assetId);
      }
      this.setState({showModalDetail: !this.state.showModalDetail});
    }

    const renderModalDetail = () => {
      const { assetDetailPopup, showModalDetail } = this.state;
      return (
        <Modal isOpen={showModalDetail} toggle={() => toggleModalDetail()} centered>
          <ModalBody>
          <div className="table-responsive">
            <table className="table table-striped m-b-0">
              <tbody>
                <tr>
                  <th>Nama</th>
                  <th>{assetDetailPopup?.name}</th>
                </tr>
                <tr>
                  <td>Serial Number</td>
                  <td>{assetDetailPopup?.serialNumber}</td>
                </tr>
                <tr>
                  <td>Kategori</td>
                  <td>{assetDetailPopup?.categoryName}</td>
                </tr>
                <tr>
                  <td>Tahun</td>
                  <td>{assetDetailPopup?.year}</td>
                </tr>
              </tbody>
            </table>
          </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-white" onClick={() => toggleModalDetail()}>Tutup</button>
          </ModalFooter>
        </Modal>
      )
    }

    const clicked = (area) => {
      toggleModalDetail(area.id);
    };

    const clickedOutside = (evt) =>{
      const coords = { x: evt.nativeEvent.layerX, y: evt.nativeEvent.layerY };
      const payload = {
        layoutId: this.state.selectedLayout,
        assetId: this.state.dataAsset._id,
        coords: [coords.x, coords.y, 10]
      }

      Services.putAssetToLayout(payload)
        .then(res => {
          this.getLayoutAssetCoordinates(payload.layoutId, payload.assetId);
        })
        .catch(err => console.log(err));
    };

    const enterArea = (area) => {
      this.setState({
        hoveredArea: area,
      });
    };

    const leaveArea = (area) => {
      this.setState({
        hoveredArea: null,
      });
    };

    return (
      <div className="col-xl-12">
        <Panel className={this.state.layoutLoading ? 'panel-loading':''}>
          <PanelHeader noButton={true}>Layout Aset</PanelHeader>
          <PanelBody>
            {this.state.layoutLoading && (
              <div className="panel-loader">
                <span className="spinner-small"></span>
              </div>
            )}
            <div className="form-group row">
              <label className='col-md-auto col-form-label'>Layout</label>
              <div className='col-md-4'>
                <select
                  onChange={handleLayoutChange}
                  type="select" 
                  className="form-control"
                  value={this.state.selectedLayout}
                >
                  <option value=''> - pilih - </option>
                  {layoutOptions}
                </select>
              </div>
            </div>
            {this.state.selectedLayout &&
              (
              <>
                <div 
                  className='border' 
                  id="map-layout-asset" 
                  style={{width:'1002px', cursor: 'pointer'}}
                  data-for='layout-asset-tooltip'
                  data-tip={''}
                >
                  <ImageMapper
                    src={`${BASE_URL}/layout-zone-file/${this.state.layoutFile}`}
                    map={{name: "map-layout", areas: this.state.mapAreas}}
                    width={1000}
                    onClick={area => clicked(area)}
                    onImageClick={evt => clickedOutside(evt)}
                    onMouseEnter={area => enterArea(area)}
                    onMouseLeave={area => leaveArea(area)}
                  />
                </div>
                <ReactTooltip 
                  id="layout-asset-tooltip" 
                  getContent={() => (this.state.hoveredArea ? this.state.hoveredArea.name : null)}
                />
              </>
              )
            }
          </PanelBody>
        </Panel>
        {this.state.showModalDetail &&
          renderModalDetail()
        }
      </div>
    )
  }

  renderHistoryChecklist = () => {
    const { dataAsset } = this.state;
    let no = 1;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>History Checklist</PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Deskripsi</th>
                    <th>Durasi</th>
                    <th>Diupdate Oleh</th>
                    <th>Diupdate Tanggal</th>
                  </tr>
                </thead>
                <tbody>
                  {dataAsset?.logHistory?.reverse().map((item, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{no++}</td>
                        <td>{item?.desc}</td>
                        <td>{item?.totalTime}</td>
                        <td>{item?.updateBy}</td>
                        <td>{moment(item?.updateDate).format('DD-MM-YYYY')}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderHistoryComplaint = () => {
    const { dataComplaint } = this.state;
    let no = 0;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>History Komplain</PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Tanggal Laporan</th>
                    <th>Pelapor</th>
                    <th>Judul</th>
                    <th>Lokasi</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataComplaint.map((item, index) => {
                      no++;
                      return(
                        <tr key={index}>
                          <td>{no}</td>
                          <td>{moment(item.createDate).format('DD-MM-YYYY')}</td>
                          <td>{item.createBy}</td>
                          <td>{item.title}</td>
                          <td>{item.location}</td>
                          <td>{item.status}</td>
                          <td>
                            <Link
                              to={{
                                pathname: '/reporting/complaint-data-detail',
                                state: {
                                  selectedData: item
                                }
                              }}
                            >
                            <button
                              className="btn btn-sm btn-success width-70">Detail
                            </button>
                            </Link>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  render(){
    return(
      <div>
        {this.renderBreadcrumb()}
        <div className="row">
          {this.renderDetailAsset()}
          {this.renderLayoutMapper()}
          {this.renderHistoryChecklist()}
          {this.renderHistoryComplaint()}
        </div>
        {/* {this.state.alert} */}
      </div>
    )
  }
};

export default withNotification(DetailAsset);
